import { cn } from '@/lib/utils/tailwind';

import type { CardContainerProps } from './types';

export const Header = ({ children, className = '' }: CardContainerProps) => (
  <div className={cn(className)}>{children}</div>
);
